import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';

import { $cartState } from '../../../../store/models/cart';

import styles from './styles.module.scss';

const OneTimeCard = () => {
  const { t } = useTranslation();
  const { selectedProductSize } = useUnit($cartState);
  const { selectedProduct } = useUnit($cartState);

  return (
    <div className={styles.oneTimeCard}>
      <h3>{t("oneTimePurchase")}</h3>
      <div className={styles.price}>
        €{selectedProductSize ? selectedProduct?.actual_price : 0}
      </div>
      <p className="fs-14">{t("singleDeliveryProcessed")}</p>
    </div>
  );
};

export default OneTimeCard;
